import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea422ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-14 ant-col-xl-16" }, " Contas a Pagar ", -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-6 ant-col-xl-8" }
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = { style: {"text-align":"right"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Duplicar", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "N.Identificação"
}, "N.Identificação", -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_16 = { class: "ant-col ant-col-xs-18 ant-col-xl-16" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "N.Identificação"
}, "N.Identificação", -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "ant-col ant-col-xs-6 ant-col-xl-8" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_23 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-3"
}
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_25 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-3"
}
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = {
  key: 0,
  class: "ant-col ant-col-xs-4 ant-col-xl-4"
}
const _hoisted_28 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_32 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = { key: 4 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"5px","margin-bottom":"5px"}
}, null, -1))
const _hoisted_44 = { class: "ant-row" }
const _hoisted_45 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_48 = { class: "ant-col ant-col-xs-8 ant-col-xl-2" }
const _hoisted_49 = { class: "ant-col ant-col-xs-8 ant-col-xl-2" }
const _hoisted_50 = { class: "ant-col ant-col-xs-8 ant-col-xl-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "vezes", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, null, -1))
const _hoisted_53 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_54 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_55 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_tipo_tributo = _resolveComponent("selecionar-tipo-tributo")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_selecionar_marcador_titulo_financeiro = _resolveComponent("selecionar-marcador-titulo-financeiro")!
  const _component_card = _resolveComponent("card")!
  const _component_titulo_financeiro_repasse = _resolveComponent("titulo-financeiro-repasse")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_titulo_financeiro_boleto = _resolveComponent("titulo-financeiro-boleto")!
  const _component_titulo_financeiro_cheque = _resolveComponent("titulo-financeiro-cheque")!
  const _component_titulo_financeiro_documento_fiscal = _resolveComponent("titulo-financeiro-documento-fiscal")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_titulo_financeiro_centro_custo = _resolveComponent("titulo-financeiro-centro-custo")!
  const _component_titulo_financeiro_detalhamento = _resolveComponent("titulo-financeiro-detalhamento")!
  const _component_titulo_financeiro_anexo = _resolveComponent("titulo-financeiro-anexo")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_titulo_financeiro_historico = _resolveComponent("titulo-financeiro-historico")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_sazonalidade = _resolveComponent("selecionar-sazonalidade")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    style: {"z-index":"999"},
    width: 1200,
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile ? 'full-modal ss-modal-financeiro' : 'scroll-modal ss-modal-financeiro',
    maskClosable: false
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.tituloFinanceiroBase.status), 1),
            _createElementVNode("span", {
              class: _normalizeClass('ant-badge-status-dot ss-span-status ' + _ctx.tituloFinanceiroBase.classeStatus)
            }, null, 2)
          ])
        ])
      ])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      (_ctx.props.operacao.tipoPermissaoDados != _ctx.EPermissaoDados.Visualizar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.DuplicarTitulo()))
            }, _hoisted_8),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      ((_ctx.modalBase.computedVisivel))
        ? (_openBlock(), _createBlock(_component_a_skeleton, {
            key: 0,
            loading: _ctx.telaBase.carregando,
            paragraph: { rows: 15 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  (_ctx.state.controleAlcada && _ctx.props.operacao.codigoRegistro === 0)
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 0,
                        message: "O controle de alçada está ativo. Todas novas contas a pagar serão lançadas com aprovação pendente.",
                        type: "warning",
                        closable: ""
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.state.controleAlcada && _ctx.props.operacao.codigoRegistro !== 0 && (_ctx.tituloFinanceiroBase.titulo.status === _ctx.EStatusTituloFinanceiro.Pendente || _ctx.tituloFinanceiroBase.titulo.status === _ctx.EStatusTituloFinanceiro.BaixadoParcialmente))
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 1,
                        message: "O controle de alçada está ativo. Após salvar a conta a receber o status dela retornará para aprovação pendente.",
                        type: "warning",
                        closable: ""
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_a_form_item, {
                            label: "Empresas",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                value: _ctx.tituloFinanceiroBase.titulo.codigoEmpresa,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.codigoEmpresa) = $event)),
                                style: {"width":"100%"},
                                optionFilterProp: "label",
                                allowClear: true,
                                options: _ctx.telaBase.empresasDisponiveis,
                                disabled: ""
                              }, null, 8, ["value", "options"])
                            ]),
                            _: 1
                          })
                        ])
                      ], 512), [
                        [_vShow, _ctx.telaBase.apresentarEmpresas]
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo de Documento",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tipo_documento_financeiro, {
                                codigoSelecionado: _ctx.tituloFinanceiroBase.titulo.codigoTipoDocumentoFinanceiro,
                                "onUpdate:codigoSelecionado": [
                                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.codigoTipoDocumentoFinanceiro) = $event)),
                                  _cache[5] || (_cache[5] = ($event: any) => (_ctx.atualizarTipoDocumentoFinanceiroSelecionado()))
                                ],
                                empresas: [_ctx.tituloFinanceiroBase.titulo.codigoEmpresa],
                                disabled: !_ctx.tituloFinanceiroBase.editavel,
                                contasPagar: true,
                                movimentacaoSaidaPagamentos: (!_ctx.tituloPendente())
                              }, null, 8, ["codigoSelecionado", "empresas", "disabled", "movimentacaoSaidaPagamentos"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.tituloFinanceiroBase.titulo.codigo === 0?'ant-col ant-col-xs-24 ant-col-xl-9':'ant-col ant-col-xs-24 ant-col-xl-5')
                        }, [
                          (_ctx.tituloFinanceiroBase.titulo.parcela == 0 || _ctx.tituloFinanceiroBase.titulo.parcela == undefined || _ctx.tituloFinanceiroBase.titulo.codigo === 0)
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 0,
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                label: _withCtx(() => [
                                  _hoisted_13,
                                  _createVNode(_component_a_tooltip, {
                                    placement: "top",
                                    title: "Informe aqui o número do documento, título ou qualquer outra numeração que você deseje identificar este lançamento."
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_icone, {
                                        class: "ss-icone-informacao-campo",
                                        nome: "informacao-campo"
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.numeroTitulo) = $event)),
                                    disabled: !_ctx.tituloFinanceiroBase.editavel,
                                    onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.atualizarNumeroBoleto && _ctx.atualizarNumeroBoleto(...args)))
                                  }, null, 40, _hoisted_14), [
                                    [_vModelText, _ctx.tituloFinanceiroBase.titulo.numeroTitulo]
                                  ])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_a_form_item, {
                                    class: "ss-margin-campos",
                                    rules: [{ required: true }]
                                  }, {
                                    label: _withCtx(() => [
                                      _hoisted_17,
                                      _createVNode(_component_a_tooltip, {
                                        placement: "top",
                                        title: "Informe aqui o número do documento, título ou qualquer outra numeração que você deseje identificar este lançamento."
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_icone, {
                                            class: "ss-icone-informacao-campo",
                                            nome: "informacao-campo"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.numeroTitulo) = $event)),
                                        disabled: !_ctx.tituloFinanceiroBase.editavel,
                                        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.atualizarNumeroBoleto && _ctx.atualizarNumeroBoleto(...args)))
                                      }, null, 40, _hoisted_18), [
                                        [_vModelText, _ctx.tituloFinanceiroBase.titulo.numeroTitulo]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Parcela",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "ant-input ss-input-numerico",
                                        min: "1",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.parcela) = $event)),
                                        disabled: !_ctx.tituloFinanceiroBase.editavel
                                      }, null, 8, _hoisted_20), [
                                        [_vModelText, _ctx.tituloFinanceiroBase.titulo.parcela]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                        ], 2),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_a_form_item, {
                            label: "Vencimento",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.tituloFinanceiroBase.titulo.dataVencimento,
                                "onUpdate:dataSelecionada": [
                                  _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.dataVencimento) = $event)),
                                  _cache[12] || (_cache[12] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                ],
                                disabled: !_ctx.tituloFinanceiroBase.editavel
                              }, null, 8, ["dataSelecionada", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_a_form_item, {
                            label: "Competência",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.tituloFinanceiroBase.titulo.dataCompetencia,
                                "onUpdate:dataSelecionada": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.dataCompetencia) = $event)),
                                disabled: !_ctx.state.editavelBaixa || !_ctx.tituloFinanceiroBase.editavelBaixa
                              }, null, 8, ["dataSelecionada", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        (_ctx.tituloFinanceiroBase.titulo.status === _ctx.EStatusTituloFinanceiro.Baixado)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createVNode(_component_a_form_item, {
                                label: "Baixa",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data, {
                                    dataSelecionada: _ctx.tituloFinanceiroBase.titulo.dataBaixa,
                                    "onUpdate:dataSelecionada": [
                                      _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.dataBaixa) = $event)),
                                      _cache[15] || (_cache[15] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                    ],
                                    disabled: !_ctx.tituloFinanceiroBase.editavel
                                  }, null, 8, ["dataSelecionada", "disabled"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                quantidadeCasasDecimais: 2,
                                valor: _ctx.tituloFinanceiroBase.titulo.valorTotal,
                                "onUpdate:valor": [
                                  _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.valorTotal) = $event)),
                                  _cache[17] || (_cache[17] = ($event: any) => (_ctx.atualizarSaldo()))
                                ],
                                disabled: !_ctx.tituloFinanceiroBase.editavel
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        ((_ctx.tituloFinanceiroBase.titulo.codigo > 0))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createVNode(_component_a_form_item, {
                                label: "Saldo",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_campo_numerico, {
                                    monetario: true,
                                    quantidadeCasasDecimais: 2,
                                    valor: _ctx.tituloFinanceiroBase.titulo.saldo,
                                    "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.saldo) = $event)),
                                    disabled: !_ctx.tituloFinanceiroBase.editavel
                                  }, null, 8, ["valor", "disabled"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        (_ctx.tituloFinanceiroBase.tipoDocumentoFinanceiro.meioPagamento === _ctx.EMeioPagamento.Tributo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createVNode(_component_a_form_item, {
                                label: "Tipo de Tributo",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_tipo_tributo, {
                                    valor: _ctx.tituloFinanceiroBase.titulo.tipoTributo,
                                    "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.tipoTributo) = $event)),
                                    disabled: !_ctx.tituloFinanceiroBase.editavel
                                  }, null, 8, ["valor", "disabled"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_a_form_item, {
                            label: "Pessoa",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_pessoa, {
                                empresas: [_ctx.tituloFinanceiroBase.titulo.codigoEmpresa],
                                codigoSelecionado: _ctx.tituloFinanceiroBase.titulo.codigoPessoa,
                                "onUpdate:codigoSelecionado": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.codigoPessoa) = $event)),
                                apresentarRelacoes: true,
                                disabled: !_ctx.tituloFinanceiroBase.editavel,
                                recursoOrigem: _ctx.telaBase.identificadorRecurso
                              }, null, 8, ["empresas", "codigoSelecionado", "disabled", "recursoOrigem"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_selecionar_conta, {
                            codigoSelecionado: _ctx.tituloFinanceiroBase.titulo.codigoConta,
                            "onUpdate:codigoSelecionado": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.codigoConta) = $event)),
                            empresas: [_ctx.tituloFinanceiroBase.titulo.codigoEmpresa],
                            disabled: !_ctx.tituloFinanceiroBase.editavel,
                            required: true
                          }, null, 8, ["codigoSelecionado", "empresas", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                codigoSelecionado: _ctx.tituloFinanceiroBase.titulo.codigoPlanoContaCategoria,
                                "onUpdate:codigoSelecionado": [
                                  _cache[22] || (_cache[22] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.codigoPlanoContaCategoria) = $event)),
                                  _cache[23] || (_cache[23] = ($event: any) => (_ctx.obterCentrosCustoContaContabil()))
                                ],
                                empresas: [_ctx.tituloFinanceiroBase.titulo.codigoEmpresa],
                                disabled: !_ctx.state.editavelBaixa || !_ctx.tituloFinanceiroBase.editavelBaixa
                              }, null, 8, ["codigoSelecionado", "empresas", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (_ctx.tituloFinanceiroBase.tipoDocumentoFinanceiro.meioPagamento === _ctx.EMeioPagamento.Pix)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_a_form_item, {
                                label: "QRCode do PIX",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.qrCodePix) = $event)),
                                    disabled: _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar
                                  }, null, 8, _hoisted_34), [
                                    [_vModelText, _ctx.tituloFinanceiroBase.titulo.qrCodePix]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_a_form_item, {
                                label: "Chave do PIX",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.chavePix) = $event)),
                                    disabled: _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar
                                  }, null, 8, _hoisted_36), [
                                    [_vModelText, _ctx.tituloFinanceiroBase.titulo.chavePix]
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_a_form_item, {
                            label: "Marcadores",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_marcador_titulo_financeiro, {
                                marcadoresSelecionados: _ctx.tituloFinanceiroBase.marcadores,
                                "onUpdate:marcadoresSelecionados": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.tituloFinanceiroBase.marcadores) = $event)),
                                tipo: _ctx.ETipoTituloFinanceiro.Pagar,
                                disabled: _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar
                              }, null, 8, ["marcadoresSelecionados", "tipo", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  ((_ctx.tituloFinanceiroBase.tituloRepassado))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createVNode(_component_a_skeleton, {
                          loading: _ctx.tituloFinanceiroBase.carregandoRepasse
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_titulo_financeiro_repasse, {
                              empresa: _ctx.tituloFinanceiroBase.titulo.codigoEmpresa,
                              repasse: _ctx.tituloFinanceiroBase.titulo.repasse
                            }, null, 8, ["empresa", "repasse"])
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.verificarTipoBoleto(_ctx.tituloFinanceiroBase.tipoDocumentoFinanceiro.meioPagamento))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createVNode(_component_a_skeleton, {
                          loading: _ctx.tituloFinanceiroBase.carregandoBoleto
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_titulo_financeiro_boleto, {
                              empresa: _ctx.tituloFinanceiroBase.titulo.codigoEmpresa,
                              codigoRegistro: _ctx.tituloFinanceiroBase.titulo.codigo,
                              tipoTitulo: _ctx.ETipoTituloFinanceiro.Pagar,
                              boleto: _ctx.tituloFinanceiroBase.titulo.boleto,
                              "onUpdate:boleto": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.boleto) = $event)),
                              editavel: _ctx.tituloFinanceiroBase.editavel
                            }, null, 8, ["empresa", "codigoRegistro", "tipoTitulo", "boleto", "editavel"])
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tituloFinanceiroBase.tipoDocumentoFinanceiro.meioPagamento === _ctx.EMeioPagamento.Cheque)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createVNode(_component_a_skeleton, {
                          loading: _ctx.tituloFinanceiroBase.carregandoCheque
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_titulo_financeiro_cheque, {
                              codigoRegistro: _ctx.tituloFinanceiroBase.titulo.codigo,
                              empresa: _ctx.tituloFinanceiroBase.titulo.codigoEmpresa,
                              cheque: _ctx.tituloFinanceiroBase.titulo.cheque,
                              "onUpdate:cheque": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.cheque) = $event)),
                              editavel: _ctx.tituloFinanceiroBase.editavel
                            }, null, 8, ["codigoRegistro", "empresa", "cheque", "editavel"])
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, {
                        key: "1",
                        tab: "DOCUMENTO FISCAL"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_skeleton, {
                            loading: _ctx.tituloFinanceiroBase.carregandoDocumentoFiscal
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_titulo_financeiro_documento_fiscal, {
                                codigoRegistro: _ctx.tituloFinanceiroBase.titulo.codigo,
                                documentoFiscal: _ctx.tituloFinanceiroBase.titulo.documentoFiscal,
                                "onUpdate:documentoFiscal": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.documentoFiscal) = $event)),
                                editavel: _ctx.state.editavelBaixa && _ctx.tituloFinanceiroBase.editavelBaixa
                              }, null, 8, ["codigoRegistro", "documentoFiscal", "editavel"])
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      }),
                      (_ctx.state.apresentaCentroCusto)
                        ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: "2",
                            tab: "CENTRO DE CUSTO"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_skeleton, {
                                loading: _ctx.tituloFinanceiroBase.carregandoCentrosCusto
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_titulo_financeiro_centro_custo, {
                                    visivel: _ctx.modalBase.computedVisivel,
                                    valor: _ctx.tituloFinanceiroBase.titulo.valorTotal,
                                    codigoRegistro: _ctx.tituloFinanceiroBase.titulo.codigo,
                                    centrosCusto: _ctx.tituloFinanceiroBase.centrosCusto,
                                    "onUpdate:centrosCusto": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.tituloFinanceiroBase.centrosCusto) = $event)),
                                    editavel: _ctx.tituloFinanceiroBase.editavel
                                  }, null, 8, ["visivel", "valor", "codigoRegistro", "centrosCusto", "editavel"])
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_tab_pane, {
                        key: "3",
                        tab: "DETALHAMENTO"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_skeleton, {
                            loading: _ctx.tituloFinanceiroBase.carregandoDetalhamentos
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_titulo_financeiro_detalhamento, {
                                visivel: _ctx.modalBase.computedVisivel,
                                valor: _ctx.tituloFinanceiroBase.titulo.saldo,
                                empresa: _ctx.tituloFinanceiroBase.titulo.codigoEmpresa,
                                codigoRegistro: _ctx.tituloFinanceiroBase.titulo.codigo,
                                codigoPlanoContaCategoria: _ctx.tituloFinanceiroBase.titulo.codigoPlanoContaCategoria,
                                detalhamentos: _ctx.tituloFinanceiroBase.titulo.detalhamentos,
                                "onUpdate:detalhamentos": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.detalhamentos) = $event)),
                                totalDetalhado: _ctx.tituloFinanceiroBase.totalDetalhado,
                                "onUpdate:totalDetalhado": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.tituloFinanceiroBase.totalDetalhado) = $event)),
                                centrosCusto: _ctx.tituloFinanceiroBase.centrosCusto,
                                "onUpdate:centrosCusto": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.tituloFinanceiroBase.centrosCusto) = $event)),
                                editavel: _ctx.tituloFinanceiroBase.editavel,
                                onAtualizarSaldoPeloDetalhamento: _ctx.atualizarSaldoPeloDetalhamento
                              }, null, 8, ["visivel", "valor", "empresa", "codigoRegistro", "codigoPlanoContaCategoria", "detalhamentos", "totalDetalhado", "centrosCusto", "editavel", "onAtualizarSaldoPeloDetalhamento"])
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "4",
                        tab: "ANEXOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_skeleton, {
                            loading: _ctx.tituloFinanceiroBase.carregandoAnexos
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_titulo_financeiro_anexo, {
                                codigoTituloFinanceiro: _ctx.tituloFinanceiroBase.titulo.codigo,
                                tipo: _ctx.ETipoTituloFinanceiro.Pagar,
                                empresa: _ctx.tituloFinanceiroBase.titulo.codigoEmpresa,
                                anexos: _ctx.tituloFinanceiroBase.titulo.anexos,
                                "onUpdate:anexos": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.anexos) = $event)),
                                editavel: _ctx.tituloFinanceiroBase.editavel
                              }, null, 8, ["codigoTituloFinanceiro", "tipo", "empresa", "anexos", "editavel"])
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "5",
                        tab: "OBSERVAÇÕES"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card, { titulo: " " }, {
                            default: _withCtx(() => [
                              _createVNode(_component_editor_html, {
                                value: _ctx.tituloFinanceiroBase.titulo.observacoes,
                                "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.observacoes) = $event)),
                                disabled: _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar
                              }, null, 8, ["value", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      ((_ctx.tituloFinanceiroBase.titulo.codigo > 0))
                        ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: "6",
                            tab: "HISTÓRICO"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_skeleton, {
                                loading: _ctx.tituloFinanceiroBase.carregandoHistorico
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_titulo_financeiro_historico, {
                                    visivel: _ctx.modalBase.computedVisivel,
                                    registros: _ctx.tituloFinanceiroBase.registrosAtividade
                                  }, null, 8, ["visivel", "registros"])
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir)
                    ? (_openBlock(), _createBlock(_component_card, { key: 5 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.tituloFinanceiroBase.repetir,
                            "onUpdate:checked": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.tituloFinanceiroBase.repetir) = $event)),
                            onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.checkRepetir()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Repetir")
                            ]),
                            _: 1
                          }, 8, ["checked"]),
                          (_ctx.tituloFinanceiroBase.repetir)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Parcela Inicial",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "number",
                                          class: "ant-input ss-input-numerico",
                                          min: "1",
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.parcela) = $event)),
                                          disabled: !_ctx.tituloFinanceiroBase.editavel
                                        }, null, 8, _hoisted_46), [
                                          [_vModelText, _ctx.tituloFinanceiroBase.titulo.parcela]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Período",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_sazonalidade, {
                                          valor: _ctx.tituloFinanceiroBase.sazonalidade,
                                          "onUpdate:valor": [
                                            _cache[39] || (_cache[39] = ($event: any) => ((_ctx.tituloFinanceiroBase.sazonalidade) = $event)),
                                            _cache[40] || (_cache[40] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                          ]
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (_ctx.tituloFinanceiroBase.sazonalidade === _ctx.ESazonalidade.customizada)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_48, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Intervalo",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                min: "1",
                                                class: "ant-input ss-input-numerico",
                                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.tituloFinanceiroBase.sazonalidadeCustomizada) = $event)),
                                                onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                              }, null, 544), [
                                                [_vModelText, _ctx.tituloFinanceiroBase.sazonalidadeCustomizada]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_49, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Durante",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                min: "1",
                                                class: "ant-input ss-input-numerico",
                                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.tituloFinanceiroBase.repeticao) = $event)),
                                                onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                              }, null, 544), [
                                                [_vModelText, _ctx.tituloFinanceiroBase.repeticao]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_50, [
                                          _createVNode(_component_a_form_item, {
                                            label: " ",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_51
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _hoisted_52
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_53, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Durante",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                min: "1",
                                                class: "ant-input ss-input-numerico",
                                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.tituloFinanceiroBase.repeticao) = $event)),
                                                onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                              }, null, 544), [
                                                [_vModelText, _ctx.tituloFinanceiroBase.repeticao]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_54, [
                                          _createVNode(_component_a_form_item, {
                                            label: " ",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.obterDescricaoSazonalidade()), 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ], 64)),
                                  _createElementVNode("div", _hoisted_55, [
                                    (_ctx.UtilitarioGeral.valorValido(_ctx.tituloFinanceiroBase.titulo.dataVencimento) && _ctx.tituloFinanceiroBase.repeticao > 0)
                                      ? (_openBlock(), _createBlock(_component_a_alert, {
                                          key: 0,
                                          description: _ctx.obterMensagemRepeticao(),
                                          style: {"white-space":"pre"},
                                          type: "info",
                                          "show-icon": ""
                                        }, null, 8, ["description"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}